import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import InfoPanel from './info-panel';
import { informationYouNeedBulletContent, thingsToDoBulletContent, mrsText, } from '../constants';
const InfoWrapper = styled.div `
  align-items: center;
  background-color: ${COLORS.lightestGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px auto;
  padding-bottom: 30px;

  div {
    width: 45%;
  }

  p {
    font-size: 18px;
    line-height: 24px;
  }
`;
const InformationYouNeed = ({ activeFlow }) => (React.createElement(InfoWrapper, null,
    React.createElement(InfoPanel, { headingText: "Information you'll need to set up Returns", content: informationYouNeedBulletContent }),
    React.createElement(InfoPanel, { headingText: mrsText.thingsYouNeedToDoHeading, content: thingsToDoBulletContent(activeFlow) })));
export default InformationYouNeed;
